import { ContainerModule } from 'inversify';
import ProfileService from '../features/profile/data/service/ProfileService';
import ProfileRepository from '../features/profile/data/ProfileRepository';
import { ProfileServiceInterface } from '../features/profile/data/service/ProfileService.types';
import { ProfileRepositoryInterface } from '../features/profile/domain/ProfileRepositoryInterface';
import { VerificationServiceInterface } from 'src/features/verification/data/service/VerificationService.types';
import VerificationService from 'src/features/verification/data/service/VerificationService';
import { VerificationRepositoryInterface } from 'src/features/verification/domain/VerificationRepositoryInterface';
import VerificationRepository from 'src/features/verification/data/VerificationRepository';
import { TwilioVerificationServiceInterface } from 'src/features/verification/data/service/TwilioVerificationService.types';
import TwilioVerificationService from 'src/features/verification/data/service/TwilioVerificationService';
import { TwilioVerificationRepositoryInterface } from 'src/features/verification/domain/TwilioVerificationRepositoryInterface';
import TwilioVerificationRepository from 'src/features/verification/data/TwilioVerificationRepository';
import {
  SendOtpUseCaseInterface,
  VerifyOtpUseCaseInterface,
} from 'src/features/verification/domain/useCases/types';
import VerifyOtpUseCase from 'src/features/verification/domain/useCases/VerifyOtpUseCase';
import SendOtpUseCase from 'src/features/verification/domain/useCases/SendOtpUseCase';

export const profileBindings = new ContainerModule((bind) => {
  // Services
  bind<ProfileServiceInterface>(ProfileService).to(ProfileService);
  bind<VerificationServiceInterface>(VerificationService).to(
    VerificationService
  );
  bind<TwilioVerificationServiceInterface>(TwilioVerificationService).to(
    TwilioVerificationService
  );

  // Repositories
  bind<ProfileRepositoryInterface>(ProfileRepository).to(ProfileRepository);
  bind<VerificationRepositoryInterface>(VerificationRepository).to(
    VerificationRepository
  );
  bind<TwilioVerificationRepositoryInterface>(TwilioVerificationRepository).to(
    TwilioVerificationRepository
  );

  // Use cases
  bind<VerifyOtpUseCaseInterface>(VerifyOtpUseCase).to(VerifyOtpUseCase);
  bind<SendOtpUseCaseInterface>(SendOtpUseCase).to(SendOtpUseCase);
});
